import React from 'react';
import { NewScreenComponent } from './NewScreen';
import { getUserInfo } from '../utils/user';
import { useNewScreenQuery } from '@intigral/domain/lib/presentation/hooks/useNewScreenQuery';

type TvodsScreenProps = {
    screenName: string;
    screenKey: string;
};

export const TvodsScreen: React.FC<TvodsScreenProps> = ({ screenName, screenKey }) => {
    const userInfo = getUserInfo();
    const { isLoading, isError, data, error } = useNewScreenQuery(
        screenName,
        screenKey,
        'deviceType=pc',
        userInfo.apiKey
    );
    const components = data?.data?.content?.carousels ?? [];

    return <NewScreenComponent isLoading={isLoading} isError={isError} components={components} screenKey={screenKey} />;
};
